import { PdvService } from './../providers/pdv/pdv.service';
import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';
import { NgModel } from '@angular/forms';
import { mapsService } from '../providers/maps/maps.service';

declare var google: any;

@Directive({
  selector: '[googleplace]',
  providers: [NgModel],
  host: {
    '(input)': 'onInputChange()'
  }
})

export class GoogleplaceDirective {
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  maps;
  modelValue: any;
  autocomplete: any;
  private _el: HTMLElement;


  constructor(
    private el: ElementRef,
    private model: NgModel,
    private mapsService: mapsService,
    private pdvService: PdvService
  ) {
    const subs4 = this.pdvService.pdv.subscribe((pdv) => {
      this.maps = pdv.maps;
    });
  }
  ngOnInit() {
    setTimeout(
      () => {
        this._el = this.el.nativeElement;
        this.modelValue = this.model;
        var input = this._el;
        this.mapsService.doSomethingGoogley(this.maps).then((data) => {
          this.autocomplete = new google.maps.places.Autocomplete(input, { types: ["geocode"], componentRestrictions: { country: "fr" } });
          google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
            var place = this.autocomplete.getPlace();
            this.invokeEvent(place);
          });
        })
      }, 1000
    )
  }
  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }

  onInputChange() {
  }
}


// WEBPACK FOOTER //
// ./src/directives/googleplace.ts